/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect } from 'react';

import { usePlpStore } from 'components/modules/plp/DataStore';
import { isBrowser } from 'lib/hooks/useIsomorphicLayoutEffect';
import UrlValidation from 'lib/utils/helpers/urlValidation';

export const useUrlFactory = () => {
  let urlFactory: UrlValidation | null;
  const { url: currentUrl } = usePlpStore();

  if (!isBrowser()) {
    urlFactory = new UrlValidation(currentUrl);
  } else {
    urlFactory = new UrlValidation();
  }

  useEffect(() => {
    urlFactory?.makeObj();
    return () => {
      urlFactory = null;
    };
  });

  return urlFactory;
};
